module.exports = "/_next/static/images/bounty-accept-post-instructions-2640ffbf45516015f50ac37884951ad1.png";